import React, { FC } from "react";
import { useSelector } from "react-redux";

import { useRegisterAndFetchInitialNotifications } from "src/store/notifications/useActions";
import { useGlobalFetch } from "../../../store/globalFetch/useActions";
import { getIdsOfVisibleModulesOrderedByModuleOrder } from "../../../store/modules/selectors";
import NavMenu, { NavMenuProps } from "./NavMenu";

export type ContainerProps = Pick<NavMenuProps, "hideLogin">;

const Container: FC<ContainerProps> = (props) => {
  useGlobalFetch("navMenu");
  useGlobalFetch("homepage");
  useRegisterAndFetchInitialNotifications();

  const moduleIds = useSelector(getIdsOfVisibleModulesOrderedByModuleOrder);

  return <NavMenu {...props} moduleIds={moduleIds} />;
};

export default Container;
